module.exports = __webpack_public_path__ + "static/media/fly0020.2e4b44dd.webp";